import { combineReducers } from "redux";
import billReducer from "./reducer";

const reducer = combineReducers({
  billReducer,
});

export default reducer;
